<template>
  <div>
    <!-- 组合套餐卡片 -->
    <li
      class="dkillItem"
      @click="enterDetails(item)"
    >
      <p class="dkillTitle"><i v-if="item.name&&item.name.substr(0, 1) == '【'"></i>{{ item.name }}</p>
      <div class="activityTag">
        <TagComponent
          v-for="(tagItem, tagIndex) in tagType(item)"
          :key="tagIndex"
          :text="tagItem"
          :color="tagItem==='套餐'?'blue':'yellow-no-bg'"
        />
      </div>
      <div class="TimeHours">
        <p class="Time">
          <img src="@/assets/img/public/icon.png" /> 包含{{ item.courseNum }}门课程
        </p>
      </div>
      <!-- 教师头像 -->
      <ol class="teacherList">
        <ul v-if="item.teacherRespVOList">
          <li
            v-for="(teacherItem, teaind) in item.teacherRespVOList.length > 3
              ? item.teacherRespVOList.slice(0, 3)
              : item.teacherRespVOList"
            :key="teaind"
          >
            <div class="teabg">
              <img
                :src="teacherItem.teacherHead || defaultImg"
                alt=""
              />
            </div>

            <p>{{ teacherItem.name }}</p>
          </li>
        </ul>
        <!-- 售价 -->
        <div class="coursePrice">
          <del v-if="coursePriceDel(item)">￥{{ item.originalPrice }}</del>
          <span
            class="courseType"
            v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount"
          >拼团价</span>
          <span
            v-else-if="item.promotionLabel"
            class="courseType"
          >{{
            item.promotionLabel === 1 ? '折后价' : item.promotionLabel === 4 ? '券后价' : '限时价'
          }}</span>
          <p class="showPic">
            <template v-if="item.productDiscountRespVO && item.productDiscountRespVO.isGroupDiscount">
              <b>¥</b>
              <span>{{ item.productDiscountRespVO.discountMinPrice }}</span>
            </template>
            <template v-else>
              <b v-if="item.sellPrice === 0 && !item.promotionLabel ? false : true">¥</b>
              <span :class="{ fontSty: item.sellPrice === 0 && !item.promotionLabel }">{{
                item.sellPrice === 0 && !item.promotionLabel ? '限时免费' : item.sellPrice
              }}</span>
            </template>
          </p>
        </div>
      </ol>
      <div class="dkillCardBto">
        <p class="endTime">{{ item.salesVolume }}人已购买</p>
        <div
          class="consultBtn"
          @click.stop="openChat"
        >立即咨询</div>
      </div>
    </li>
  </div>
</template>

<script>
import wx from 'weixin-js-sdk';
import TagComponent from '@/components/commonComponents/TagComponent.vue';
import defaultImg from '@/assets/img/loginImg/default.png';

export default {
  components: {
    TagComponent,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      defaultImg,
    };
  },
  computed: {
    tagType() {
      return (val) => {
        const type = [];
        // if (val.isUnionDiscount) {
        //   type.push('联报优惠');
        // }
        // if (val.isSingleDiscount) {
        //   type.push('单减活动');
        // }
        if (val.isCouponDiscount) {
          type.push('优惠券');
        }
        if (val.packageDiscountRespVO && val.packageDiscountRespVO.isBuyGiftGiveawaysDiscount) {
          type.push('购课赠好礼');
        }
        // if (val.productDiscountRespVO && val.productDiscountRespVO.isFullDiscount) {
        //   type.push('满减活动');
        // }
        type.push('套餐');
        return type;
      };
    },
  },
  methods: {
    coursePriceDel(item) {
      return item?.productDiscountRespVO?.isGroupDiscount || item.promotionLabel;
    },
    // 进入详情
    enterDetails(courseInfo) {
      // 判断是否App
      if (this.$root.$data.isApp) {
        this.$sendToApp('goToCombinationCourse', Number(courseInfo.packageId), false);
        return;
      }
      const { roomId } = this.$route.query;
      if (roomId) {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
            liveRoomId: roomId,
          },
        });
      } else {
        this.$router.push({
          path: '/combinationCourse',
          query: {
            combinationId: courseInfo.packageId,
          },
        });
      }
    },
    openChat() {
      if (this.$root.$data.isApp) {
        this.$sendToApp(
          'openNewWebView',
          {
            url: 'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
          },
          false,
        );
        return;
      }
      if (this.$root.miniprogram) {
        console.log(1111);
        wx.miniProgram.navigateTo({
          url: '/subPackages/mantisChat/mantisChat',
        });
        return;
      }
      window.open(
        'https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=7926&mpid=6194a29668991d6b4e202137',
      );
    },
  },
  filters: {
    changeDeadLineTime(value) {
      return value.split(' ')[0];
    },
  },
};
</script>

<style lang="scss" scoped>
.dkillItem {
  margin-bottom: 32px;
  padding: 20px 29px 16px 25px;
  background: $bgWhite;
  border-radius: 16px;
  box-shadow: 0 2px 9px 0 #eee;
}

.dkillTitle {
  display: -webkit-box;
  overflow: hidden;
  color: $fontColorBlack;
  font-weight: bold !important;
  font-size: 33px;
  line-height: 45px;
  @extend .ellipsis-2;
  i {
    margin-left: -18px;
  }
}
.activityTag {
  display: flex;
  flex-wrap: wrap;
  margin: 9px 5px 11px 0;
  font-size: 0;

  .tag-component {
    margin-right: 14px;
  }
}
.TimeHours {
  display: flex;
  align-items: center;
  margin-top: 20px;
  line-height: 30px;
  > img {
    width: 24px;
    height: 24px;
    margin-right: 5px;
  }
  p {
    margin-right: 14px;
    color: $fontColorGray;
    font-size: 24px;
    > img {
      position: relative;
      top: 2px;
      width: 24px;
      height: 24px;
    }
  }
  span {
    margin-left: 12px;
    color: $fontColorGray;
    font-size: 24px;
  }
}
.teacherList {
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 46px;
  ul {
    display: flex;
    li {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      // width: 64px;
      margin-right: 34px;
      .teabg {
        width: 63px;
        height: 63px;
        background-color: $teabg;
        border-radius: 50%;
      }
      img {
        width: 63px;
        height: 63px;
        border-radius: 50%;
      }
      p {
        max-width: 100px;
        margin-top: 9px;
        overflow: hidden;
        color: $fontColorGray;
        font-size: 22px;
        line-height: 28px;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
  }
}
.coursePrice {
  position: absolute;
  right: 0;
  bottom: 5px;
  display: flex;
  align-items: baseline;
  del {
    margin-right: 11px;
    color: $delcolor;
    font-size: 24px;
  }
  .courseType {
    color: $redColor;
    font-weight: 500;
    font-size: 24px;
  }
}
.showPic {
  margin-left: 6px;
  font-weight: bold;
  font-size: 28px;
  text-align: center;
  b {
    margin: 0 4px;
    color: $redColor;
    font-size: 28px;
  }
  span {
    color: $redColor;
    font-weight: bold;
    font-size: 38px;
  }
  .fontSty {
    font-size: 30px;
  }
}
.dkillCardBto {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 13px;
  padding-top: 20px;
  border-top: 2px solid rgba(151, 151, 151, 0.1);
  zoom: 1;
}

.endTime {
  color: $fontColorGray;
  font-size: 24px;
  span {
    color: $fontColorGray;
    font-size: 24px;
  }
}
.consultBtn {
  width: 128px;
  height: 46px;
  color: #fff;
  font-weight: 400;
  font-size: 24px;
  line-height: 46px;
  text-align: center;
  background: #ff7f41;
  border-radius: 23px;
}
</style>
